import React, { useState, useContext, useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoins } from '@fortawesome/free-solid-svg-icons'
import ToolBar from './ToolBar'
import EditText from './EditText'
import HeaderAccount from './HeaderAccount'
import SideBar from './SideBar'
import Records from './Records'
import Board from './Board'
import Footer from './Footer'
import { DraftContext } from './ContextProvider'
import apiServices from '../services/apiServices'

function EditWrapper({ children, setting }) {
  const {
    toolbarTitle = '',
    toolbarTitleDesc = '',
    showInput,
    moduleTitle,
    moduleKeyword,
    records,
    showToolbar = false,
    boards = [],
    boardStyle,
    switchBoard = () => {},
  } = setting
  const [setModalShow] = useState(false)
  const [showRecord, setShowRecord] = useState(false)
  const [showBoard, setShowBoard] = useState(false)

  const handleShow = () => setModalShow(true)

  // 版本紀錄
  const openRecord = () => {
    setShowRecord(true)
    setShowBoard(false)
  }
  const closeRecord = () => setShowRecord(false)

  // 變更面板
  const openBoard = () => {
    setShowRecord(false)
    setShowBoard(true)
  }
  const closeBoard = () => setShowBoard(false)

  // 手機版開關選單
  const [toggleNav, setToggleNav] = useState(false)
  const toggleMobileNav = (isOpen) => {
    setToggleNav(isOpen)
  }

  const { screenshotRef, targetRef } = useContext(DraftContext)

  return (
    <div className="content edit-content flex-1">
      <EditHeader
        setting={{
          moduleTitle,
        }}
      />
      <SideBar
        setting={{
          toggleMobileNav,
          toggleNav,
          showInput,
          handleShow,
          keyword: moduleKeyword,
          records,
        }}
      />
      <div className={`tab-group ${toggleNav ? 'open' : ''}`}>
        <ToolBar
          setting={{
            toolbarTitle,
            toolbarTitleDesc,
            moduleKeyword,
            openRecord,
            openBoard,
          }}
        />
      </div>
      <div
        id="moduleContent"
        className={`module-content ${toggleNav ? 'open' : ''}`}
      >
        <div
          ref={screenshotRef}
          className={`module-body ${showToolbar ? 'hasToolbar' : ''}`}
        >
          <div ref={targetRef} className="w-100 h-100 module-body">
            {children}
          </div>
        </div>
        <Footer showRemark hasToolbar={showToolbar} />
      </div>
      {showRecord && <Records setting={{ showRecord, closeRecord }} />}
      {showBoard && (
        <Board
          setting={{
            closeBoard,
            boards,
            boardStyle,
            switchBoard,
            onClickOutside: closeBoard,
          }}
        />
      )}
    </div>
  )
}

function EditHeader({ setting }) {
  const { setDraft, list, draftId } = useContext(DraftContext)
  const { moduleTitle } = setting
  const handleInputChange = (value) => {
    setDraft({ module: { title: value } }, draftId)
  }

  const title = useMemo(() => {
    const target = list.find(({ draft_id }) => draftId === draft_id)
    return target?.title || ''
  }, [list])

  const update = async (value, id) => {
    await apiServices.data({
      path: `draft/data/${id}`,
      method: 'put',
      data: {
        title: value,
      },
    })
    // handleInputChange(value)
  }

  const [logs, setlogs] = useState({
    draftCount: {},
    pathCount: {},
    subpathCount: {},
  })
  const { draftCount, pathCount, subpathCount } = logs
  const getLogs = async () => {
    const res = await apiServices.data({
      path: `draft/logs`,
      method: 'get',
    })
    console.log(res)
    setlogs(res)
  }
  useEffect(() => {
    getLogs()
  }, [])

  return (
    <div id="header" className="fixed pageNav">
      <nav className="navbar navbar-expand-lg">
        <div className="d-flex align-items-center">
          <EditText
            setting={{
              title: title || moduleTitle,
              handleInputChange: async (value) => {
                await update(value, draftId)
                handleInputChange(value)
              },
              bgColor: '#FFFFFF',
            }}
          />
        </div>
        <div id="accountHeaderWrapper" className="d-flex">
          {/* <Button
            as="a"
            variant="primary"
            size="sm"
            target="_blank"
            href="https://tdri.surveycake.biz/admin/tw/survey/67b58d244add9/preview"
          >
            <FontAwesomeIcon icon={faStar} title="連結" />
            &ensp;獲得無限ＡＩ
          </Button> */}
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip
                className="style-dark tooltip-lg"
                style={{
                  zIndex: '9999',
                }}
              >
                <p>目前已生成{Object.keys(draftCount).length}個專案</p>
                <ul>
                  {Object.keys(pathCount)
                    .filter((key) => key !== 'undefined')
                    .map((key) => (
                      <li key={key}>
                        {key}: {pathCount[key]}次
                      </li>
                    ))}
                </ul>
                <ul>
                  {Object.keys(subpathCount)
                    .filter((key) => key !== 'undefined')
                    .map((key) => (
                      <li key={key}>
                        {key}: {subpathCount[key]}次
                      </li>
                    ))}
                </ul>
                {logs.generated && (
                  <ul>
                    <li>已生成圖片：{logs.generated}張</li>
                  </ul>
                )}
                {logs.imgs && (
                  <ul>
                    <li>已上傳圖片：{logs.imgs}張</li>
                  </ul>
                )}
              </Tooltip>
            }
          >
            <div className="w-25 text-white text-nowrap my-auto me-5">
              <FontAwesomeIcon icon={faCoins} title="用量" />
              &ensp;剩餘{Math.max(3 - Object.keys(draftCount).length, 0)}/3次
            </div>
          </OverlayTrigger>
          <HeaderAccount />
        </div>
      </nav>
    </div>
  )
}

EditWrapper.propTypes = {
  children: PropTypes.shape().isRequired,
  setting: PropTypes.shape().isRequired,
}

EditHeader.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default EditWrapper
